// extracted by mini-css-extract-plugin
export var actionText = "_pl-4";
export var container = "_pl-0";
export var leftSection = "_pl-1";
export var rightSection = "_pl-2";
export var settingsButton = "_pl-6";
export var settingsIcon = "_pl-7";
export var shortcut = "_pl-5";
export var shortcutGroup = "_pl-3";